import StateMasterList from "./stateMasterList/StateMasterList"

function StateMaster() {
    return (
        <>
            <StateMasterList />
        </>
    )
}
export default StateMaster